import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';

import { updtClientIpAddress } from '../../../../helpers/api';

class IpAddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ipAddress: null,
      error: null,
      pending: false,
    };
  }

  handleIpAddress = (event) => {
    this.setState({ ipAddress: event.target.value });
  };

  updtIpAddress = () => {
    if (!this.state.ipAddress)
      this.setState({ error: 'Invalid ipAddress!', pending: false });
    else {
      this.setState({ pending: true, error: null });
      this._asyncRequest = updtClientIpAddress(
        this.props.publicKeyHash,
        this.state.ipAddress,
      )
        .then((res) => {
          if (res.status === 'SUCCESS') {
            this.props.loadClient();
            this.props.toggleIpAddressModal();
          } else {
            this.setState({ error: res.error, pending: false });
          }
        })
        .catch((error) => {
          this.setState({ error: error.toString(), pending: false });
        });
    }
  };

  render() {
    return (
      <Modal
        size="md"
        isOpen={this.props.ipAddressModal}
        centered={true}
        backdrop="static"
        wrapClassName="modal-balance"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Update VAT Number
          </h5>
        </div>
        <div className="modal-body">
          {this.state.error && (
            <p className="text-danger">{this.state.error}</p>
          )}
          <FormGroup>
            <Label>IP Addresses</Label>

            <Row>
              <Col sm="12">
                <InputGroup className="mb-2">
                  <InputGroupAddon addonType="prepend">
                    <span className="input-group-text">
                      <small>If several, seperate with comma</small>
                    </span>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    onChange={this.handleIpAddress}
                    autoComplete="off"
                  />
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          {this.state.pending ? (
            <p>Processing...</p>
          ) : (
            <Row className="mt-3">
              <Col sm="4">
                <button
                  className="btn btn-primary btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => this.props.toggleIpAddressModal()}
                >
                  Close
                </button>
              </Col>
              <Col sm="6">
                <button
                  className="btn btn-warning btn-block waves-effect waves-light"
                  type="submit"
                  onClick={() => {
                    this.updtIpAddress();
                  }}
                >
                  Update
                </button>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    );
  }
}

export default IpAddressModal;
